export const set_search_term = 'set_search_term';
export const set_articles = 'set_articles';
export const set_isLoading = 'set_isLoading';
export const remove_article = 'remove_article';
